import { CreateTransferMealInput } from '../../lib/types/models/transfer-meal/create-transfer-meal'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTransferMeal(data: IdInput<CreateTransferMealInput>) {
  const { id, ...rest } = data

  return restApiClient
    .url(constructApiUrl(API.transferMeal.create.url, { tripFolderId: id }))
    .post<{ message: string }, CreateTransferMealInput>(rest)
}
